module.exports = __webpack_public_path__ + "img/5_119.5ce2fadc.png";